<template>
  <div>
    <el-table
      :data="descriptionData"
      :border="true"
    >
      <el-table-column
        prop="method"
        :label="$t('Fee.FeeDescriptionTitle[0]')"
      />
      <el-table-column
        prop="fee"
        :label="$t('Fee.FeeDescriptionTitle[1]')"
        class-name="pre-line"
      />
      <el-table-column
        prop="model"
        :label="$t('Fee.FeeDescriptionTitle[2]')"
      />
      <el-table-column
        prop="charger"
        :label="$t('Fee.FeeDescriptionTitle[3]')"
      />
    </el-table>
    <a
      class="link"
      href="https://www.smartdaily.com.tw/questions/5658674"
      target="_blank"
      rel="noopener"
    >
      {{ $t('Fee.ToFeeDescription') }}
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      descriptionData: [
        {
          method: this.$t('Fee.V4FeeDescriptionData[0][0]'),
          fee: this.$t('Fee.V4FeeDescriptionData[0][1]').trim(),
          model: this.$t('Fee.V4FeeDescriptionData[0][2]'),
          charger: this.$t('Fee.V4FeeDescriptionData[0][3]')
        },
        {
          method: this.$t('Fee.V4FeeDescriptionData[1][0]'),
          fee: this.$t('Fee.V4FeeDescriptionData[1][1]').trim(),
          model: this.$t('Fee.V4FeeDescriptionData[1][2]'),
          charger: this.$t('Fee.V4FeeDescriptionData[1][3]')
        },
        {
          method: this.$t('Fee.V4FeeDescriptionData[2][0]'),
          fee: this.$t('Fee.V4FeeDescriptionData[2][1]').trim(),
          model: this.$t('Fee.V4FeeDescriptionData[2][2]'),
          charger: this.$t('Fee.V4FeeDescriptionData[2][3]')
        },
        {
          method: this.$t('Fee.V4FeeDescriptionData[3][0]'),
          fee: this.$t('Fee.V4FeeDescriptionData[3][1]').trim(),
          model: this.$t('Fee.V4FeeDescriptionData[3][2]'),
          charger: this.$t('Fee.V4FeeDescriptionData[3][3]')
        },
        {
          method: this.$t('Fee.V4FeeDescriptionData[4][0]'),
          fee: this.$t('Fee.V4FeeDescriptionData[4][1]').trim(),
          model: this.$t('Fee.V4FeeDescriptionData[4][2]'),
          charger: this.$t('Fee.V4FeeDescriptionData[4][3]')
        },
        {
          method: this.$t('Fee.V4FeeDescriptionData[5][0]'),
          fee: this.$t('Fee.V4FeeDescriptionData[5][1]').trim(),
          model: this.$t('Fee.V4FeeDescriptionData[5][2]'),
          charger: this.$t('Fee.V4FeeDescriptionData[5][3]')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  @include basicTable;
}
.link {
  color: $mainColor;
  &:hover {
    text-decoration: underline;
  }
}
::v-deep .pre-line {
  .cell {
    white-space: pre-line !important;
  }
}
</style>
